import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import { css } from "styled-components";
import { StyledImageContainer } from "../../../components/ModalComponents/StyledModalComponents";
import {
    currentlyEditingSleeperSelector, customNavigationSlice, isIncorporateModalOpenSelector,
    setIsIncorporateModalOpen,
    setIsSummaryModalOpen
} from "../../../redux/slices/customNavigation";
import { getAdaptiveFontSize } from "../../../utils/styling.utils";
import {
  convertLbsToKg,
  getEvrScore,
  getFinalEvrScore,
  parseFeetAndInch,
  parseFeetInchToCm
} from "../../../utils/evrscore.utils";
import {
  isSingleSleeperSelector,
  primarySleeperBmiSelector,
  primarySleeperEvrScoreSelector,
  primarySleeperHeightSelector,
  primarySleeperUnitSystemSelector,
  primarySleeperWeightSelector,
  secondarySleeperBmiSelector,
  secondarySleeperEvrScoreSelector,
  secondarySleeperHeightSelector,
  secondarySleeperUnitSystemSelector,
  secondarySleeperWeightSelector,
  setPrimarySleeperBMI,
  setPrimarySleeperEvrScore,
  setSecondarySleeperBMI,
  setSecondarySleeperEvrScore
} from "../../../redux/slices/mattressConfiguration";

import {useDispatch, useSelector} from "react-redux";
import TextTransition, { presets } from "react-text-transition";

import svg_background from "../../../assets/images/Path_7821.png";

import useMediaQuery from "@mui/material/useMediaQuery";
import ContainedButton from "../../../components/Buttons/ContainedButton";
import EvrScore from "../../../components/ModalComponents/EvrScore";

const GlobalEvrScoreMobile = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
  const { t } = useTranslation();
  //Media Queries
  const isSmartphoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };
  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const glow = css`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `;

    const isIncorporateModalOpen = useSelector(isIncorporateModalOpenSelector);
    const score = getFinalEvrScore({
        isPrimarySleeper: isSingleSleeper || currentlyEditingSleeper === 1,
    });



  const editingSleeper1 = currentlyEditingSleeper === 1;
  const primarySleeperUnitSystem = useSelector(
    primarySleeperUnitSystemSelector
  );
  const secondarySleeperUnitSystem = useSelector(
    secondarySleeperUnitSystemSelector
  );

  const primarySleeperHeight = useSelector(primarySleeperHeightSelector);
  const primarySleeperWeight = useSelector(primarySleeperWeightSelector);
  const secondarySleeperHeight = useSelector(secondarySleeperHeightSelector);
  const secondarySleeperWeight = useSelector(secondarySleeperWeightSelector);
  const primarySleeperBMI = useSelector(primarySleeperBmiSelector);
  const secondarySleeperBMI = useSelector(secondarySleeperBmiSelector);
  const primarySleeperEvrScore = useSelector(primarySleeperEvrScoreSelector);
  const secondarySleeperEvrScore = useSelector(secondarySleeperEvrScoreSelector);

  // BMI CALCULATIONS
  const calculateBMIMetric = (weight, height) => {
    return (weight / height / height) * 10000;
  };
  const calculateBMIImperial = (weight, height) => {
    const { feet, inch } = parseFeetAndInch(height);
    const heightInInch = feet * 12 + inch;
    return (weight / heightInInch / heightInInch) * 703;
  };

  const calculatePrimarySleeperBMI = () => {
    if (primarySleeperUnitSystem === "metric") {
      return calculateBMIMetric(primarySleeperWeight, primarySleeperHeight);
    } else {
      return calculateBMIImperial(primarySleeperWeight, primarySleeperHeight);
    }
  };

  const calculateSecondarySleeperBMI = () => {
    if (secondarySleeperUnitSystem === "metric") {
      return calculateBMIMetric(secondarySleeperWeight, secondarySleeperHeight);
    } else {
      return calculateBMIImperial(
        secondarySleeperWeight,
        secondarySleeperHeight
      );
    }
  };

  const getBMI = () => {
    if (isSingleSleeper || editingSleeper1) {
      return dispatch(setPrimarySleeperBMI(calculatePrimarySleeperBMI()));
    } else {
      return dispatch(setSecondarySleeperBMI(calculateSecondarySleeperBMI()));
    }
  };

  const formatBMI = () => {
    getBMI();
    const result =
      isSingleSleeper || editingSleeper1
        ? primarySleeperBMI
        : secondarySleeperBMI;
    if (result === Infinity || isNaN(result)) {
      return "N/A";
    } else {
      return result.toFixed(2);
    }
  };

  // EVRSCORE CALCULATIONS
  const convertSleeperData = (heightInInch, weightInLbs) => {
    const heightInCm = parseFeetInchToCm(heightInInch);
    const weightInKg = convertLbsToKg(weightInLbs);
    return { heightInCm, weightInKg };
  };

  const calculatePrimarySleeperEvrScore = () => {
    if (primarySleeperUnitSystem === "metric") {
      const evrScore = getEvrScore(primarySleeperWeight, primarySleeperHeight);
      return dispatch(setPrimarySleeperEvrScore(evrScore));
    } else {
      const { heightInCm, weightInKg } = convertSleeperData(
        primarySleeperHeight,
        primarySleeperWeight
      );
      let evrScore = getEvrScore(weightInKg, heightInCm);
      evrScore = getFinalEvrScore({isPrimarySleeper: true});
      console.log(evrScore);
      return dispatch(setPrimarySleeperEvrScore(evrScore));
    }
  };

  const calculateSecondarySleeperEvrScore = () => {
    if (secondarySleeperUnitSystem === "metric") {
      let evrScore = getEvrScore(
        secondarySleeperWeight,
        secondarySleeperHeight
      );
      evrScore = getFinalEvrScore({isPrimarySleeper: false});
      return dispatch(setSecondarySleeperEvrScore(evrScore));
    } else {
      const { heightInCm, weightInKg } = convertSleeperData(
        secondarySleeperHeight,
        secondarySleeperWeight
      );
      const evrScore = getEvrScore(weightInKg, heightInCm);
      return dispatch(setSecondarySleeperEvrScore(evrScore));
    }
  };

  const calculateEvrScore = () => {
    console.log('calculating evrscore 1');
    if (isSingleSleeper || editingSleeper1) {
      return calculatePrimarySleeperEvrScore();
    } else {
      return calculateSecondarySleeperEvrScore();
    }
  };

  const formatEvrScore = () => {
    calculateEvrScore();

    const result =
      isSingleSleeper || editingSleeper1
        ? primarySleeperEvrScore
        : secondarySleeperEvrScore;
    console.log(result);
    if (result === Infinity || isNaN(result)) {
      return "N/A";
    } else {
      return result;
    }
  };

  // calculateEvrScore();

  return (
    <div
      style={{
        position: "absolute",
        top: "75px",
        right: "135px",
        width: "30px",
        height: "30px",
      }}
    >
      {(editingSleeper1 && (primarySleeperHeight) && (primarySleeperWeight)) ||
      (!editingSleeper1 && (secondarySleeperHeight) && (secondarySleeperWeight)) ?
        <>
          <StyledImageContainer className="">
            <img
              style={{
                width: "160px",
                height: "100px",
              }}
              src={svg_background}
            ></img>
          </StyledImageContainer>
          <div
            style={{
              position: "absolute",
              top: "20px",
              left: "35px",
              width: "200px",
              fontWeight: "bold",
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: "0.9rem",
            }}
          >
            {t("Your Evr Score")}
          </div>
          <div
          style={{
          position: "absolute",
          top: "45px",
          left: "65px",
          width: "30px",
          height: "30px",
          // textDecoration: "underline",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.7rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          animation: `${glow} 2s linear infinite`,
        }}
          >
        {/*<TextTransition*/}
        {/*  text={getFinalEvrScore({*/}
        {/*    isPrimarySleeper: isSingleSleeper || currentlyEditingSleeper === 1,*/}
        {/*  })}*/}
        {/*  noOverflow={true}*/}
        {/*  springConfig={presets.wobbly}*/}
        {/*/>*/}
          <div>{score}</div>
          </div>
          <ContainedButton
          className="col-auto evrbed-help"
          styles={{
          textTransform: "upperCase",
          fontSize: getAdaptiveFontSize({
          screenWidthHooks,
          fontSize: 0.8,
        }),
          marginTop: "4vh",
          visibility: score > 0 ? 'visible' : 'hidden'
        }}
          onClick={() => {

          // console.log(score);
          if (score > 0) {
          dispatch(setIsIncorporateModalOpen(!isIncorporateModalOpen));
        }
        }
        }
          >
        {t("How does this affect")}
          <br></br>
          {t("my evrbed?")}
          </ContainedButton>
        </>
        :
        <></>
      }
    </div>
  );
};

export default GlobalEvrScoreMobile;
